import Icon from '../components/Icon.vue'

Icon.register({"credit-card-alt":{"width":2304,"height":1792,"paths":[{"d":"M0 1504v-608h2304v608q0 66-47 113t-113 47h-1984q-66 0-113-47t-47-113zM640 1280v128h384v-128h-384zM256 1280v128h256v-128h-256zM2144 128q66 0 113 47t47 113v224h-2304v-224q0-66 47-113t113-47h1984z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/credit-card-alt.js
// module id = LBRn
// module chunks = 0